import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, Tooltip, makeStyles } from '@material-ui/core'
import ShowChartIcon from '@material-ui/icons/ShowChartOutlined'
import BarChartIcon from '@material-ui/icons/BarChartOutlined'

// Two-button toggle for the trend tool's chart type (line vs vertical
// bar). Visual conventions match allocation's ChartTypeToggle so the
// panel toolbar reads as a consistent row of peer toggles.

const useStyles = makeStyles(() => ({
  row: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2
  },
  button: {
    padding: 5,
    borderRadius: 4,
    border: '1px solid transparent',
    color: 'var(--color-neutral-700, #555)',
    '&:hover': {
      backgroundColor: 'var(--theme-color-surface-d2, #e8e8e8)'
    }
  },
  buttonActive: {
    backgroundColor: 'var(--theme-color-surface-d2, #e8e8e8)',
    color: 'var(--color-neutral-900, #222)'
  },
  icon: {
    fontSize: 16,
    display: 'block'
  }
}))

const OPTIONS = [
  { value: 'line', label: 'Line', Icon: ShowChartIcon },
  { value: 'bar', label: 'Bar', Icon: BarChartIcon }
]

export default function ChartTypeToggle ({ value, onChange }) {
  const classes = useStyles()

  return (
    <div className={classes.row} role='group' aria-label='Trend chart type'>
      {OPTIONS.map(({ value: optValue, label, Icon }) => {
        const active = value === optValue
        return (
          <Tooltip key={optValue} title={label} placement='bottom' enterDelay={400}>
            <IconButton
              size='small'
              className={`${classes.button} ${active ? classes.buttonActive : ''}`}
              onClick={() => onChange(optValue)}
              aria-label={label}
              aria-pressed={active}
            >
              <Icon className={classes.icon} />
            </IconButton>
          </Tooltip>
        )
      })}
    </div>
  )
}

ChartTypeToggle.propTypes = {
  value: PropTypes.oneOf(['line', 'bar']),
  onChange: PropTypes.func.isRequired
}
